import React from "react";
import "./SubscriptionMessage.css"; 

const SubscriptionMessage = ({
  onClose,
  message = "Please login to use this function.",
  actionLabel = "Login",
  actionPath = "/login",
}) => {
  return (
    <>
      {/* Fullscreen overlay to disable interaction */}
      <div className="subscription-overlay"></div> 

      {/* Subscription Message */}
      <div className="subscription-message">
        <p className="non-blur">{message}</p>
        <div className="subscription-buttons">
          <button className="non-blur" onClick={onClose}>OK</button>
          <button
            className="non-blur"
            onClick={() => {
              window.location.href = actionPath;
            }}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </>
  );
};

export default SubscriptionMessage;
